export default "dist/images/block-blog-posts-portfolio.8a3cb30.png";